<template>
  <main class="container error-page text-center">
    <EmptyState title="Page not found." description="This page does not exist or may have moved.">
      <template #action>
        <router-link class="btn btn-yellow" :to="destination">
          {{ loggedIn ? "Back to your lists" : "Go to login" }}
        </router-link>
      </template>
    </EmptyState>
  </main>
</template>

<script>
import EmptyState from "@/components/EmptyState.vue";

export default {
  name: "NotFound",
  components: {
    EmptyState,
  },
  computed: {
    loggedIn() {
      return this.$store.getters.loggedIn;
    },
    destination() {
      return this.loggedIn ? { name: "Lists" } : { name: "Login" };
    },
  },
};
</script>

<style scoped>
.error-page {
  min-height: calc(100vh - 56px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.error-page :deep(.empty-state) {
  width: 100%;
  color: #f5f6f4;
}
</style>
